module.exports = __webpack_public_path__ + "static/img/tomato.c9ab38a6.webp";